import React, { useRef } from "react";
import HTMLFlipBook from "react-pageflip";
import amplifyOutputs from "../../../amplify_outputs.json";

const bucket = amplifyOutputs.storage.bucket_name;
const region = amplifyOutputs.storage.aws_region;

export default function BookViewer({
  pages,
  flipBookOptions = {}, // Parámetros personalizados para HTMLFlipBook
  useAbsolute = true, // Propiedad para habilitar/deshabilitar la clase 'absolute'
  useHScreen = true, // Propiedad para habilitar/deshabilitar la clase 'h-screen'
}) {
  const book = useRef(null);
  // Función para reproducir sonido
  const playFlipSound = () => {
    const sound = new Audio(
      `https://${bucket}.s3.${region}.amazonaws.com/publico/siguiente-pagina.mp3`,
    ); // Crear nueva instancia para evitar superposición
    sound.currentTime = 0; // Reiniciar desde el inicio
    sound.play().catch((error) => console.error("Error playing sound:", error));
  };

  // Funciones para ir hacia adelante y atrás al hacer clic en los márgenes
  const goToNextPage = () => {
    if (book.current) {
      const currentPage = book.current.pageFlip().getCurrentPageIndex();
      const totalPages = book.current.pageFlip().getPageCount();

      if (currentPage < totalPages - 2) {
        // Verifica que NO sea la última página
        book.current.pageFlip().flipNext();
        playFlipSound();
      }
    }
  };

  const goToPreviousPage = () => {
    if (book.current) {
      const currentPage = book.current.pageFlip().getCurrentPageIndex();

      if (currentPage > 1) {
        // Verifica que NO sea la primera página
        book.current.pageFlip().flipPrev();
        playFlipSound();
      }
    }
  };

  // Opciones predeterminadas para HTMLFlipBook
  const defaultOptions = {
    width: 400,
    height: 500,
    minWidth: 315,
    minHeight: 400,
    maxWidth: 600,
    maxHeight: 800,
    size: "stretch",
    maxShadowOpacity: 0.5,
    showCover: true,
    className: "border bg-gray-200 shadow-2xl",
  };

  // Fusionar las opciones predeterminadas con las personalizadas
  const bookOptions = { ...defaultOptions, ...flipBookOptions };

  return (
    <div
      className={`flex ${useHScreen ? "h-screen pb-24" : ""} items-center justify-center bg-gray-300`}
    >
      <HTMLFlipBook ref={book} {...bookOptions}>
        {pages.map((page, index) => (
          <div key={index} className="demoPage">
            <img
              src={page}
              alt={`Page ${index + 1}`}
              className="h-full w-full object-contain"
            />
          </div>
        ))}
      </HTMLFlipBook>

      {/* Margen izquierdo para pasar hacia atrás */}
      <div
        onClick={goToPreviousPage}
        className={`${useAbsolute ? "absolute" : ""} left-0 top-0 h-full w-1/5 cursor-pointer`}
      />

      {/* Margen derecho para pasar hacia adelante */}
      <div
        onClick={goToNextPage}
        className={`${useAbsolute ? "absolute" : ""} right-0 top-0 h-full w-1/5 cursor-pointer`}
      />
    </div>
  );
}
